module.exports = __webpack_public_path__ + "static/media/summary.5316f4cd.svg";